import { createSelector } from "@reduxjs/toolkit";
import { getHiddenVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getHiddenVariationMods";

/**
 * Whether one mod is currently toggled out of the merchant's own preview.
 *
 * Reads through `getHiddenVariationMods`, so the id is scoped to the
 * previewed variation and a stale id is impossible to observe.
 */
export const getIsModHiddenFactory = (modId: string) =>
  createSelector(getHiddenVariationMods, (hiddenMods) =>
    hiddenMods.some((mod) => mod.id === modId)
  );
